const banks = [
  { key: 'absa', val: 'Absa' },
  { key: 'fnb', val: 'FNB' },
  { key: 'standard_bank', val: 'Standard Bank' },
  { key: 'capitec', val: 'Capitec' },
  { key: 'Investec', val: 'Investec' },
  { key: 'nedbank', val: 'Nedbank' },
  { key: 'postbank', val: 'Postbank' }
];

const allowedRelationships = [
  {key: 'parent', val: 'Parent'},
  {key: 'parent_in_law', val: 'Parent in law'},
  {key: 'brother', val: 'Brother'},
  {key: 'sister', val: 'Sister'},
  {key: 'uncle', val: 'Uncle'},
  {key: 'aunt', val: 'Aunt'},
  {key: 'nephew', val: 'Nephew'},
  {key: 'niece', val: 'Niece'},
  {key: 'additional_spouse', val: 'Additional spouse'}
];

module.exports = {
  banks,
  allowedRelationships
};



// WEBPACK FOOTER //
// ./src/helpers/data.js